export const ACTIVE_USER = 'ACTIVE_USER';